import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderReseller from "../Components/Reseller/headerReseller";
import ListReseller from "../Components/Reseller/listReseller";
// import ViewReseller from "../Components/";

const ResellerRoutes = () => {
  return (
    <Routes>
      <Route path="/reseller" element={<HeaderReseller></HeaderReseller>}></Route>
      <Route path="/reseller_list" element={<ListReseller></ListReseller>}></Route>
      <Route path="/transaction_list" element={<ListReseller></ListReseller>}></Route>
      {/* <Route path="/agent/add" element={<AddTeamMember></AddTeamMember>}></Route>
      <Route
        path="/agent/edit/:id"
        element={<EditTeamMember></EditTeamMember>}
      ></Route> */}
      {/* <Route path="/reseller/view/:id" element={<ViewReseller />}></Route> */}
    </Routes>
  );
};

export default ResellerRoutes;
